import { gql } from '@apollo/client';

// ENG-2845: soft-archive / restore loan tape upload-history rows. Plural input mirrors archivePools.
export const ARCHIVE_LOAN_TAPES = gql`
  mutation ArchiveLoanTapes($input: ArchiveLoanTapesInput!) {
    archiveLoanTapes(input: $input) {
      success
      message
      results {
        tape_id
        success
        message
      }
    }
  }
`;

export const UNARCHIVE_LOAN_TAPES = gql`
  mutation UnarchiveLoanTapes($input: UnarchiveLoanTapesInput!) {
    unarchiveLoanTapes(input: $input) {
      success
      message
      results {
        tape_id
        success
        message
      }
    }
  }
`;
